<template>
<div>
  <div v-if="activeGroup" id="sidebar-id">
    <v-list>
      <v-list-tile>
        <v-list-tile-action>
          <v-icon>work_outline</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ activeGroup.projectTitle }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-divider></v-divider>
      <v-list-tile active-class="green--text" :to="{ name: 'home' }">
        <v-list-tile-action>
          <v-icon>dashboard</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Dashboard</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile active-class="green--text" :to="{ name: 'calendar' }">
        <v-list-tile-action>
          <v-icon>event</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Calendar</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile active-class="green--text" :to="{ name: 'posts' }">
        <v-list-tile-action>
          <v-icon>insert_drive_file</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Posts</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile active-class="green--text" :class="$route.name === 'members' ? 'active' : ''" :to="{ name: 'members' }">
        <v-list-tile-action>
          <v-badge color="green lighten-2">
            <span slot="badge">{{
        activeGroup.members.length
        }}</span>
            <v-icon>recent_actors</v-icon>
          </v-badge>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>
            Members
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </div>

  <div>
    <!-- Slot where all other page content will be inserted -->
    <slot v-if="isMember && !isLoading"></slot>

    <!-- If they are not a member, show the generic error message -->
    <div v-else-if="!isMember && !isLoading" style="margin-top: 10%;">
      <h1>Error loading project data...</h1>
      <h2>Please make sure you are a member of the project.</h2>
      <h2>Please make sure the project exists.</h2>
    </div>
    <div v-else>
      <div class="loading loading-lg"></div>
    </div>
  </div>
</div>
</template>

<script>
import {
  checkAccess
} from "@/scripts/groupFuncs";
import {
  db
} from "@/firebaseConfig";

// The sidebar is in charge of managing the group's initial load state.
export default {
  name: "SideBar",
  data() {
    return {
      sidebarActive: false,
      activeGroup: null,
      isMember: false,
      isLoading: true
    };
  },
  created() {
    this.loadGroupData(this.$route.params.groupID);
  },
  methods: {
    loadGroupData(groupID) {
      // console.log("Sidebar: Loading Group Data function...");

      // Make sure the user is part of the group
      checkAccess(this.$store.getters.uid, this.$route.params.groupID)
        .then(() => {
          // If they are... load the group's data.
          this.$bind(
            "activeGroup",
            db.collection("projects").doc(groupID)
          ).then(active => {
            this.activeGroup === active;
            this.$store.commit("setActiveGroup", {
              groupID: active.id,
              details: active
            });
          });

          this.isMember = true;
          this.isLoading = false;
        })
        .catch(() => {
          // console.log("You are not a member!");
          this.isLoading = false;
        });
    }
  },
  watch: {
    "$route.params.groupID" (id) {
      // console.log(
      //   "Sidebar: Active Group Changed - Getting new data from firestore"
      // );
      this.loadGroupData(id);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Navigation/SideBar.vue